export const totalWealth = [
  { value: '0 - 50000', label: '0 - 50000' },
  { value: '50000 - 100000', label: '50000 - 100000' },
  { value: '100000 - 250000', label: '100000 - 250000' },
  { value: '250000 - 500000', label: '250000 - 500000' },
  { value: '500000 - 1000000', label: '500000 - 1000000' },
  { value: '1000000 - 2500000', label: '1000000 - 2500000' },
  { value: '2500000 - 5000000', label: '2500000 - 5000000' },
  { value: '5000000 - 10000000', label: '5000000 - 10000000' },
  { value: '10000000 - 25000000', label: '10000000 - 25000000' },
  { value: '25000000 - 50000000', label: '25000000 - 50000000' },
  { value: '50000000 or more', label: '50000000 or more' }
]
